module.exports = __webpack_public_path__ + "static/mobileprocess-40e34b675e71255637713171dea84b5e.png";